import { Link } from 'react-router-dom';
import { ChartBarIcon } from '@heroicons/react/24/outline';
import Card from '../components/ui/Card';
import { DATA_PROJECTS, dataProjectPath } from '../data/projects';

export default function Data() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Data</h1>
        <p className="mt-2 text-gray-600 max-w-2xl">
          Open a project to view its charts.
        </p>
      </div>

      <h2 className="text-xl font-semibold text-gray-900 mb-4">Projects</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {DATA_PROJECTS.map((project) => (
          <Card key={project.slug} className="h-full !p-0 overflow-hidden">
            <Link to={dataProjectPath(project.slug)} className="block h-full p-6">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <ChartBarIcon className="h-6 w-6 text-primary" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs font-semibold uppercase tracking-wide text-primary mb-1">Project</p>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">{project.title}</h3>
                  <p className="text-sm text-gray-600">{project.description}</p>
                </div>
              </div>
            </Link>
          </Card>
        ))}
      </div>
    </div>
  );
}
